/* eslint-disable react/no-find-dom-node */
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { Container, Year } from './YearSelector.styled';
import { ENTER } from '../../../utils/keyCodes';

const MIN_YEAR = 1900;
const MAX_YEAR = 2100;
const Years = Array.from(Array(MAX_YEAR - MIN_YEAR + 1)).map(
  (_value, index) => MIN_YEAR + index,
);

class YearSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleSelectedYearRef = this.handleSelectedYearRef.bind(this);
  }

  componentDidMount() {
    const node = ReactDOM.findDOMNode(this.selectedYearRef);
    if (node && node.scrollIntoView) {
      node.scrollIntoView({
        block: 'center',
      });
    }
  }

  handleSelectedYearRef(selectedYear) {
    this.selectedYearRef = selectedYear;
  }

  handleYearClick(year) {
    if (this.isYearDisabled(year)) {
      return;
    }
    const { date, onChange } = this.props;
    const newDate = new Date(date);
    newDate.setFullYear(year);
    onChange(newDate);
  }

  isYearDisabled(year) {
    const { disablePast, disableFuture } = this.props;
    const currentYear = new Date().getFullYear();

    if (disablePast && year < currentYear) {
      return true;
    }
    if (disableFuture && year > currentYear) {
      return true;
    }
    return false;
  }

  render() {
    const { date } = this.props;
    const selectedYear = date.getFullYear();
    return (
      <Container>
        {Years.map((year) => (
          <Year
            role="button"
            aria-label={year}
            tabIndex="0"
            key={year.toString()}
            ref={year === selectedYear ? this.handleSelectedYearRef : undefined}
            disabled={this.isYearDisabled(year)}
            selected={year === selectedYear}
            onClick={() => this.handleYearClick(year)}
            onKeyDown={(e) => {
              if (e.keyCode === ENTER) {
                this.handleYearClick(year);
              }
            }}
          >
            {year}
          </Year>
        ))}
      </Container>
    );
  }
}

YearSelector.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  disablePast: PropTypes.bool,
  disableFuture: PropTypes.bool,
};

YearSelector.defaultProps = {
  disablePast: false,
  disableFuture: false,
};

export default YearSelector;
